import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import {
  DataTable,
  withSelectedEntities,
  createCommandMenu
} from "@teselagen/ui";
import { map } from "lodash-es";
import { getRangeLength } from "@teselagen/range-utils";
import { getOrfColor } from "../../constants/orfFrameToColorMap";
import { connectToEditor } from "../../withEditorProps";
import { compose } from "recompose";
import getCommands from "../../commands";
import { sizeSchema, getMemoOrfs } from "./utils";
import { orfsSubmenu } from "../../MenuBar/viewSubmenu";
import { getVisFilter } from "./GenericAnnotationProperties";
class OrfProperties extends React.Component {
  constructor(props) {
    super(props);
    this.commands = getCommands(this);
  }
  onRowSelect = ([record]) => {
    if (!record) return;
    const { dispatch, editorName } = this.props;
    dispatch({
      type: "SELECTION_LAYER_UPDATE",
      payload: record,
      meta: {
        editorName
      }
    });
  };
  render() {
    const { orfs, sequenceLength, annotationVisibility } = this.props;
    const orfsToUse = map(orfs, (orf) => {
      return {
        ...orf,
        color: getOrfColor(orf),
        frame: orf.frame + 1,
        ...orf.strand === void 0 && {
          strand: orf.forward ? 1 : -1
        },
        size: getRangeLength(orf, sequenceLength),
        sizeAa: Math.floor(getRangeLength(orf, sequenceLength) / 3 - 1)
      };
    });
    return /* @__PURE__ */ jsxs(React.Fragment, { children: [
      /* @__PURE__ */ jsx(
        DataTable,
        {
          topLeftItems: getVisFilter(
            createCommandMenu(orfsSubmenu, this.commands, {
              useTicks: true
            })
          ),
          annotationVisibility,
          noPadding: true,
          noFullscreenButton: true,
          onRowSelect: this.onRowSelect,
          withSearch: false,
          formName: "orfProperties",
          noRouter: true,
          compact: true,
          isInfinite: true,
          schema: {
            fields: [
              {
                path: "color",
                type: "string",
                render: (color) => {
                  return /* @__PURE__ */ jsx("div", { style: { height: 20, width: 20, background: color } });
                }
              },
              {
                path: "sizeAa",
                displayName: "Size (aa)",
                type: "number"
              },
              sizeSchema(this.props.isProtein),
              { path: "frame", type: "number" },
              { path: "strand", type: "number" }
            ]
          },
          entities: orfsToUse
        }
      ),
      /* @__PURE__ */ jsx("br", {})
    ] });
  }
}
export default compose(
  connectToEditor((editorState) => {
    const {
      readOnly,
      annotationVisibility = {},
      sequenceData: { sequence = "" } = {},
      sequenceData,
      minimumOrfSize,
      useAdditionalOrfStartCodons
    } = editorState;
    return {
      readOnly,
      annotationVisibility,
      useAdditionalOrfStartCodons,
      orfs: getMemoOrfs(editorState),
      sequenceLength: sequence.length,
      sequenceData,
      minimumOrfSize
    };
  }),
  withSelectedEntities("orfProperties")
)(OrfProperties);
